export enum ComponentStatus {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
}

export enum ButtonFill {
  CLEAR = 'clear',
  OUTLINE = 'outline',
  SOLID = 'solid',
}

export enum ButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum SubjectIconShape {
  NONE = 'none',
  ROUND = 'round',
}

export enum ChipFill {
  OUTLINE = 'outline',
  SOLID = 'solid',
}

export enum ChipSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum SpinnerSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
